<template>
    <div :id="`content-video-${data?.id}`" class="content-video">
        <UiMediaWithVideo :media="data?.media" :video="data?.video" />
    </div>
</template>

<script setup lang="ts">
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});
</script>
